/** «Зміна податкового призначення НА» (0453, 2026-09-01). */
import { api } from './client';
import type { Page } from './catalogs';
import type { AssetKind } from './assets';

export type TaxAdjustmentMethod = 'OBLIGATION' | 'CREDIT' | 'NONE';

export const ADJUSTMENT_METHOD_UA: Record<TaxAdjustmentMethod, string> = {
  NONE: 'без ПДВ-коригування',
  OBLIGATION: 'компенсуючі зобовʼязання (198.5)',
  CREDIT: 'відновлення кредиту',
};

export interface AssetTaxPurposeItem {
  id?: string;
  line_number: number;
  asset_kind: AssetKind;
  fixed_asset_id?: string | null;
  intangible_asset_id?: string | null;
  low_value_asset_id?: string | null;
  old_tax_purpose_id?: string | null;
  new_tax_purpose_id: string;
  residual_value_snapshot: string;
  vat_rate_percent: string;
  vat_amount_override?: string | null;
  vat_amount?: string;
  adjustment_method: TaxAdjustmentMethod;
  item_note?: string | null;
}

export interface AssetTaxPurposeChange {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  comment: string | null;
  reason: string | null;
  external_source?: string | null;
  items: AssetTaxPurposeItem[];
  created_at: string;
  updated_at: string;
}

export interface AssetTaxPurposeChangeCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  reason?: string | null;
  comment?: string | null;
  items: AssetTaxPurposeItem[];
}

const BASE = '/documents/asset-tax-purpose-changes';

export const assetTaxPurpose = {
  list: (params?: { organization_id?: string; posted?: boolean;
    date_from?: string; date_to?: string; limit?: number }) =>
    api.get<Page<AssetTaxPurposeChange>>(BASE, { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<AssetTaxPurposeChange>(`${BASE}/${id}`).then((r) => r.data),
  create: (p: AssetTaxPurposeChangeCreate) =>
    api.post<AssetTaxPurposeChange>(BASE, p).then((r) => r.data),
  update: (id: string, p: Partial<AssetTaxPurposeChangeCreate>) =>
    api.patch<AssetTaxPurposeChange>(`${BASE}/${id}`, p).then((r) => r.data),
  remove: (id: string) => api.delete(`${BASE}/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<AssetTaxPurposeChange>(`${BASE}/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<AssetTaxPurposeChange>(`${BASE}/${id}/unpost`).then((r) => r.data),
};
